import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Vector from "../imagem/Vector.svg";
import avatar1 from "../imagem/perfil/avatar1.svg";
import avatar2 from "../imagem/perfil/avatar2.svg";
import avatar3 from "../imagem/perfil/avatar3.svg";
import avatar4 from "../imagem/perfil/avatar4.svg";
import avatar5 from "../imagem/perfil/avatar5.svg";
import avatar6 from "../imagem/perfil/avatar6.svg";
import avatar7 from "../imagem/perfil/avatar7.svg";
import avatar8 from "../imagem/perfil/avatar8.svg";
import avatar9 from "../imagem/perfil/avatar9.svg";
import avatar10 from "../imagem/perfil/avatar10.svg";
import avatar11 from "../imagem/perfil/avatar11.svg";
import avatar12 from "../imagem/perfil/avatar12.svg";

function Icone({ onClose, onSelecionar }) {
  const [selecionado, setSelecionado] = useState(null);

  const listaIcones = [ 
    { nome: "avatar3", imagem: avatar3 },
    { nome: "avatar6", imagem: avatar6 },
    { nome: "avatar11", imagem: avatar11 },
    { nome: "avatar9", imagem: avatar9 },
    { nome: "avatar1", imagem: avatar1 },
    { nome: "avatar7", imagem: avatar7 },
    { nome: "avatar12", imagem: avatar12 },
    { nome: "avatar8", imagem: avatar8 },
    { nome: "avatar2", imagem: avatar2 },
    { nome: "avatar5", imagem: avatar5 },
    { nome: "avatar10", imagem: avatar10 },
    { nome: "avatar4", imagem: avatar4 },
  ];

  const handleSelecionar = (icon) => {
    setSelecionado(icon.nome);
  };

  const handleConfirmar = () => {
    if (selecionado) {
      onSelecionar(selecionado);
      onClose();
    }
  };

  return (
    <Modal open={true}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 506,
          height: 493,
          bgcolor: "var(--cor-branco)",
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          p: 4,
          borderRadius: "8px",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ fontWeight: "400", fontSize: "1.375rem" }}>
            Escolha sua nova foto de perfil
          </Typography>

          <img
            src={Vector}
            alt="Fechar"
            onClick={onClose}
            style={{
              width: 18,
              height: 18,
              position: "absolute",
              right: "0.8rem",
              top: "1.0rem",
              cursor: "pointer",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            width: 486,
            height: 451,
            gap: 1,
          }}
        >
          {listaIcones.map  ((icon, index) => (
            <img
              key={index}
              src={icon.imagem}
              alt={icon.nome}
              onClick={() => handleSelecionar(icon)}
              style={{
                width: "6.2rem",
                height: "6.2rem",
                cursor: "pointer",
                border:
                  selecionado === icon.nome
                    ? "3px solid var(--cor-roxoEscuro)"
                    : "2px solid transparent",
                borderRadius: "50%",
              }}
            />
          ))}
        </Box>

        <Button
          onClick={handleConfirmar}
          sx={{
            width: 153,
            height: 39,
            borderRadius: "8px",
            bgcolor: "var(--cor-roxoEscuro)",
            color: "var(--cor-branco)",
            fontWeight: 400,
            fontSize: "1.0rem",
            textTransform: "none",
          }}
        >
          Alterar
        </Button>
      </Box>
    </Modal>
  );
}

export default Icone;